import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import BOMLookupForm from '../../../components/reporting/bom-lookup/BOMLookupForm';
import BOMLookupTable from '../../../components/reporting/bom-lookup/BOMLookupTable';

import { getBOMItemLookupReport, getKits } from '../../../actions/kitsActions';
import { getSets } from '../../../actions/setsActions';

import { getItemsByCodes } from '../../../actions/itemsActions';

const BOMLookupReportingPage = () => {
  const dispatch = useDispatch();

  const [code, setCode] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const onSubmit = async () => {
    setLoading(true);
    try {
      let item;
      if (selectedItem) {
        item = selectedItem;
      } else {
        const _items = await dispatch(getItemsByCodes([code]));
        item = _items[0] || null;
      }

      if (item) {
        await Promise.all([
          dispatch(getKits()),
          dispatch(getSets()),
        ]);
        const data = await dispatch(getBOMItemLookupReport(item));
        setData(data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='page-container reporting-page__container'>
      <div className='page-title'>BOM Item Lookup</div>
      <div className='reporting-page__body'>
        <BOMLookupForm
          onSubmit={onSubmit}
          loading={loading}
          selectedItem={selectedItem}
          onSelect={setSelectedItem}
          code={code}
          setCode={setCode}
        />

        {data && !!data.length && (
          <BOMLookupTable
            data={data}
          />
        )}
      </div>
    </div>
  );
};

export default BOMLookupReportingPage;
